import React, { useState, useEffect } from "react";
import { Container, Text, BigText } from "./styles";

export const Overview = () => {
    return (
        <Container>
            <BigText>Overview</BigText>
            <Text>GENYSES is an epic sci-fi story and cinematic metaverse where viewers co-create the story with the writers and receive rewards in the process as part of an interact-to-earn ecosystem. We are building a living, breathing narrative universe in which viewers become characters in the story, with actions that have consequences in the fictional world and ultimately determine the direction of the plot. We believe that, in the future, the barrier between creators and viewers will diminish as storytelling becomes a more interactive, collective experience. GENYSES is one of the first steps towards that future. </Text>
        </Container>
    )
}